import { Box, keyframes, styled } from '@withjoy/joykit';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AnimatedImageBox = styled(Box)`
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-in forwards;
`;
